import React, { useState, useEffect, lazy, Suspense } from "react";
import { Route, Routes, BrowserRouter, Navigate, useSearchParams } from "react-router-dom";
import ProtectedRoute from "./components/common/PrivateRoute";

// Page components
import Login from "./pages/login/Login";
import Registration from "./pages/singup/Registration";
import Setup from "./pages/singup/Setup";
import Resetpassword from "./pages/resetpassword/Resetpassword";
import Changepassword from "./pages/changepassword/Changepassword";
import Logout from "./pages/logout/Logout";
// import InsightsLayout from "./pages/insights/InsightsLayout";
import { MainLayout, WifiLayout, IntegrationsLayout, OrganisationLayout, ReviewsLayout, MarketingLayout, SurveysLayout, AIAssistantLayout } from "layout";
import AIAssistantSettings from "pages/aiAssistant/AIAssistantSettings";
import AIAssistantInstallation from "pages/aiAssistant/AIAssistantInstallation";
import AIAssistantPlayground from "pages/aiAssistant/AIAssistantPlayground";
import AIAssistantWebsite from "pages/aiAssistant/AIAssistantWebsite";
import AIAssistantKnowledge from "pages/aiAssistant/AIAssistantKnowledge";
import Dashboard from "./pages/dashboard/Dashboard";
import HomeDashboard from "./pages/home/HomeDashboard";
// import Insights from "./pages/insights/Insights";
// import FootfallInsights from "pages/insights/FootfallInsights";
// import ExternalImpactInsights from "pages/insights/ExternalImpactInsights";
// import IndustryNewsInsights from "pages/insights/industryNewsInsights/IndustryNewsInsights";
// import AllFootfallInsights from "pages/insights/AllFootfallInsights";
// import AllExternalImpactInsights from "pages/insights/AllExternalImpactInsights";
// import AllIndustryNewsInsights from "pages/insights/industryNewsInsights/AllIndustryNewsInsights";
import BChat from "pages/bChat/bChat";
import Profile from "pages/profile/Profile";
import AuthProvider from "components/common/AuthProvider";
import PublicRoute from "components/common/PublicRoute";
import Locations from "pages/locations/Locations";
import GuestPortal from "pages/guestPortal/GuestPortal";
import GuestPortalSelector from "pages/guestPortal/GuestPortalSelector";
import CaptivePortalPlanner from "pages/guestPortal/CaptivePortalPlanner";
import Networks from "pages/networks/Networks";
import OrganisationLocations from "pages/organisation/OrganisationLocations";
import OrganisationTeam from "pages/organisation/OrganistaionTeam";
import OrganisationDetails from "pages/organisation/OrganisationDetails";
import FirstTimeLogin from "./pages/firstTimeLogin/FirstTimeLogin";
import OrganisationDetailsLoginPage from "pages/firstTimeLogin/OrganisationDetailsLoginPage";
import NotFound from "pages/notFound/NotFound";
import { isMobile } from "react-device-detect";
import NotAvailableOnMobile from "pages/notAvailable/NotAvailableOnMobile";
import ActiveIntegrations from "pages/integrations/ActiveIntegrations";
import BrowseIntegrations from "pages/integrations/BrowseIntegrations";
import SignUpSuccessful from "pages/singup/SignUpSuccessful";
import { getProfile } from "api/UsersApi";
import Customers from "pages/customers/Customers";
// Marketing Pages
import MarketingAnalytics from "pages/marketing/MarketingAnalytics";
import MarketingAutomations from "pages/marketing/MarketingAutomations";
import MarketingCampaigns from "pages/marketing/MarketingCampaigns";
import MarketingTemplates from "pages/marketing/MarketingTemplates";
import MarketingAudience from "pages/marketing/MarketingAudience";
import MarketingActivityLogs from "pages/marketing/MarketingActivityLogs";
import EmailTemplateEditor from "pages/marketing/EmailTemplateEditor";
import ScratchEmailDesigner from "pages/marketing/ScratchEmailDesigner";
import MarketingWhatsappTemplateEditor from "pages/marketing/MarketingWhatsappTemplateEditor";
import MarketingSettings from "pages/marketing/MarketingSettings";

import MarketingEmailBrowserPage from "pages/marketing/MarketingEmailBrowserPage";
import MarketingEmailPreferencesPage from "pages/marketing/MarketingEmailPreferencesPage";
import MarketingOptInPage from "pages/marketing/MarketingOptInPage";
import McpConnect from "pages/mcp/McpConnect";
import MarketingSmsStudio from "pages/marketing/MarketingSmsStudio";
import { UnifiConfigSetupPage } from "pages/integrations/unifi/UnifiConfigSetupPage";
import { ActivationSuccessPage } from "pages/integrations/ActivationSuccessPage";
import { MailchimpConfigSetupPage } from "pages/integrations/mailchimp/MailchimpConfigSetupPage";
import Presence from "pages/presence/Presence";
import { AirshipConfigSetupPage } from "pages/integrations/airship/AirshipConfigSetupPage";
import { AtreemoConfigSetupPage } from "pages/integrations/atreemo/AtreemoConfigSetupPage";
import { KlaviyoConfigSetupPage } from "pages/integrations/klaviyo/KlaviyoConfigSetupPage";
import { BrevoConfigSetupPage } from "pages/integrations/brevo/BrevoConfigSetupPage";
import { DotdigitalConfigSetupPage } from "pages/integrations/dotdigital/DotdigitalConfigSetupPage";
import { GoogleAdsConfigSetupPage } from "pages/integrations/google_ads/GoogleAdsConfigSetupPage";
import { GoogleReviewsCallback } from "pages/integrations/google-reviews/GoogleReviewsCallback";
import { HubRiseCallback } from "pages/integrations/hubrise/HubRiseCallback";
import OrderingWorkspace from "pages/ordering/OrderingWorkspace";
import GuestMenuPage from "pages/ordering/GuestMenuPage";
import { GoogleReviewsConfigSetupPage } from "pages/integrations/google-reviews/GoogleReviewsConfigSetupPage";
import { TripadvisorReviewsConfigSetupPage } from "pages/integrations/tripadvisor-reviews/TripadvisorReviewsConfigSetupPage";
import { OrganisationBrands } from "pages/organisation/OrganisationBrands";
import NetworksSelector from "pages/networks/NetworksSelector";
import ReviewsDashboard from "pages/reviews/ReviewsDashboard";
import ReviewsOverview from "./pages/reviews/ReviewsOverview";
import ReviewsCompetitors from "./pages/reviews/ReviewsCompetitors";
import ReviewsList from "pages/reviews/ReviewsList";
import ReviewsLocations from "pages/reviews/ReviewsLocations";
import ReviewsBusinessProfile from "pages/reviews/ReviewsBusinessProfile";
import ReviewsPosts from "pages/reviews/ReviewsPosts";
import ReviewsAISettings from "pages/reviews/ReviewsAISettings";
import SurveyAnalytics from "pages/surveys/SurveyAnalytics";
import SurveyTemplates from "pages/surveys/SurveyTemplates";
import SurveyResponses from "pages/surveys/SurveyResponses";
import SurveyTemplateEditor from "pages/surveys/SurveyTemplateEditor";
import { APP_ROUTES } from "./routeConfig";

const OrganisationBilling = lazy(() => import("pages/organisation/OrganisationBilling"));

const hasPublicEmailPreferenceParams = (searchValue = "") => {
  const searchParams = new URLSearchParams(searchValue);
  return Boolean(searchParams.get("user_id") && searchParams.get("token"));
};

const shouldBypassProfileBootstrap = () => {
  const pathname = window.location.pathname;
  return pathname === "/email-preferences"
    || pathname === "/email-browser"
    || pathname.startsWith("/newsletter/")
    || pathname === "/mcp/connect"
    || (pathname === "/" && hasPublicEmailPreferenceParams(window.location.search));
};

function PublicRootEntry() {
  const [searchParams] = useSearchParams();

  if (searchParams.get("user_id") && searchParams.get("token")) {
    return <MarketingEmailPreferencesPage />;
  }

  return <Navigate to="/dashboard" replace />;
}

export default function RouteManager() {
  const [userRoleForAccess, setUserRoleForAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (shouldBypassProfileBootstrap()) {
      setLoading(false);
      return;
    }

    if (userRoleForAccess === null) {
      const fetchProfile = async () => {
        try {
          const profile = await getProfile();
          setUserRoleForAccess(profile.data.user_role);
        } catch (error) {
          console.error("Error fetching profile:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchProfile();
    } else {
      setLoading(false);
    }
  }, [userRoleForAccess]);

  if (loading) {
    return <div></div>;
  }

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicRootEntry />} />
          <Route path="/email-preferences" element={<MarketingEmailPreferencesPage />} />
          <Route path="/mcp/connect" element={<McpConnect />} />
          <Route path="/email-browser" element={<MarketingEmailBrowserPage />} />
          <Route path="/newsletter/:pageId" element={<MarketingOptInPage />} />
          <Route path="/order/:tableToken" element={<GuestMenuPage />} />
          <Route path="/order/:tableToken/preview" element={<GuestMenuPage preview />} />
          {isMobile ? (
            <Route path="*" element={<NotAvailableOnMobile />} />
          ) : (
            <React.Fragment>
              <Route element={<PublicRoute />}>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/forgot-password" element={<Resetpassword />} />
                <Route path="/password-reset-confirm" element={<Changepassword />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/setup" element={<Setup />} />
                <Route path="/signup-successful" element={<SignUpSuccessful />} />
              </Route>
              <Route element={<ProtectedRoute />}>
                <Route path="first-time-login" element={<FirstTimeLogin />} />
                <Route path="organisation-details" element={<OrganisationDetailsLoginPage />} />
                <Route path="/activation-success" element={<ActivationSuccessPage />} />
                <Route path="/unifi-setup" element={<UnifiConfigSetupPage />} />
                <Route path="/mailchimp-setup" element={<MailchimpConfigSetupPage />} />
                <Route path="/airship-setup" element={<AirshipConfigSetupPage />} />
                <Route path="/atreemo-setup" element={<AtreemoConfigSetupPage />} />
                <Route path="/klaviyo-setup" element={<KlaviyoConfigSetupPage />} />
                <Route path="/brevo-setup" element={<BrevoConfigSetupPage />} />
                <Route path="/dotdigital-setup" element={<DotdigitalConfigSetupPage />} />
                <Route path="/google-ads-setup" element={<GoogleAdsConfigSetupPage />} />
                <Route path="/google-reviews-setup" element={<GoogleReviewsConfigSetupPage />} />
                <Route path="/tripadvisor-reviews-setup" element={<TripadvisorReviewsConfigSetupPage />} />
                <Route path="/braze-setup" element={<Navigate to="/integrations/browse-all" replace />} />
                <Route path="/integrations/google-reviews/callback" element={<GoogleReviewsCallback />} />
                <Route path="/integrations/hubrise/callback" element={<HubRiseCallback />} />
                <Route path="/" element={<MainLayout />}>
                  <Route path="ordering" element={<Navigate to="/ordering/orders" replace />} />
                  <Route path="ordering/orders" element={<OrderingWorkspace />} />
                  <Route path="ordering/menu" element={<OrderingWorkspace />} />
                  <Route path="ordering/tables" element={<OrderingWorkspace />} />
                  <Route path="ordering/design" element={<OrderingWorkspace />} />
                  <Route path="ordering/settings" element={<Navigate to="/ordering/design" replace />} />
                  {/* Home is the default landing page for b connect. */}
                  <Route path={APP_ROUTES.home.routePath} element={<HomeDashboard />} />
                  <Route path="home" element={<Navigate to="/dashboard" replace />} />
                  {/* ChatF&B */}
                  <Route path="chat" element={<BChat />} />
                  {/* Guest WiFi Pages */}
                  <Route path="guest-wifi" element={<WifiLayout />}>
                    <Route index element={<Navigate to="connections" replace />} />
                    <Route path={APP_ROUTES.wifiConnections.routePath} element={<Dashboard />} />
                    <Route path={APP_ROUTES.captivePortal.routePath} element={<GuestPortalSelector />} />
                    <Route path={APP_ROUTES.wifiNetworks.routePath} element={<NetworksSelector />} />
                    <Route path={APP_ROUTES.wifiLocations.routePath} element={<Locations />} />
                    <Route path={APP_ROUTES.contacts.routePath} element={<Customers />} />
                  </Route>
                  {/* Keep existing bookmarks and internal links working */}
                  <Route path="portal-selector" element={<Navigate to="/guest-wifi/captive-portal" replace />} />
                  <Route path="networks-selector" element={<Navigate to="/guest-wifi/networks" replace />} />
                  <Route path="locations" element={<Navigate to="/guest-wifi/locations" replace />} />
                  <Route path="contacts" element={<Navigate to="/guest-wifi/contacts" replace />} />
                  {/* Presence Analytics Page */}
                  <Route path={APP_ROUTES.presence.routePath} element={<Presence />} />
                  {/* Guest Portal Pages */}
                  <Route path="portal-brand/:brandId/edit" element={<GuestPortal />} />
                  <Route path="portal-brand/:brandId/planner" element={<CaptivePortalPlanner />} />
                  <Route path="portal-location/:locationId/edit" element={<GuestPortal />} />
                  <Route path="portal-location/:locationId/planner" element={<CaptivePortalPlanner />} />
                  {/* Networks Pages */}
                  <Route path="networks" element={<Networks />} />
                  {/* Marketing Pages */}
                  <Route path="ai-assistant" element={<AIAssistantLayout />}>
                    <Route index element={<Navigate to="settings" replace />} />
                    <Route path={APP_ROUTES.aiAssistantSettings.routePath} element={<AIAssistantSettings />} />
                    <Route path={APP_ROUTES.aiAssistantInstallation.routePath} element={<AIAssistantInstallation />} />
                    <Route path={APP_ROUTES.aiAssistantPlayground.routePath} element={<AIAssistantPlayground />} />
                    <Route path={APP_ROUTES.aiAssistantWebsite.routePath} element={<AIAssistantWebsite />} />
                    <Route path={APP_ROUTES.aiAssistantKnowledge.routePath} element={<AIAssistantKnowledge />} />
                  </Route>
                  <Route path="marketing" element={<MarketingLayout />}>
                    <Route index element={<MarketingAnalytics />} />
                    <Route path={APP_ROUTES.marketingAnalytics.routePath} element={<MarketingAnalytics />} />
                    <Route path={APP_ROUTES.marketingAutomations.routePath} element={<MarketingAutomations />} />
                    <Route path={APP_ROUTES.marketingTemplates.routePath} element={<MarketingTemplates />} />
                    <Route path={APP_ROUTES.marketingCampaigns.routePath} element={<MarketingCampaigns />} />
                    <Route path={APP_ROUTES.marketingAudience.routePath} element={<MarketingAudience />} />
                    <Route path={APP_ROUTES.marketingActivity.routePath} element={<MarketingActivityLogs />} />
                    <Route path={APP_ROUTES.marketingSettings.routePath} element={<MarketingSettings />} />
                  </Route>
                  {/* Email Template Editor - Full screen, outside layout */}
                  <Route path="marketing/templates/editor/:templateId" element={<EmailTemplateEditor />} />
                  {/* SMS Studio - Full screen, outside layout */}
                  <Route path="marketing/templates/sms/:templateId" element={<MarketingSmsStudio />} />
                  {/* Scratch Email Designer - Full screen, outside layout */}
                  <Route path="marketing/templates/designer/:templateId" element={<ScratchEmailDesigner />} />
                  {/* WhatsApp Template Editor - Full screen, outside layout */}
                  <Route path="marketing/templates/whatsapp/:templateId" element={<MarketingWhatsappTemplateEditor />} />
                  {/* Integrations Pages */}
                  <Route path="integrations" element={<IntegrationsLayout />}>
                    <Route index element={<Navigate to="active" />} />
                    <Route path={APP_ROUTES.activeIntegrations.routePath} element={<ActiveIntegrations />} />
                    <Route path={APP_ROUTES.browseIntegrations.routePath} element={<BrowseIntegrations />} />
                  </Route>
                  {/* Organisation Pages */}
                  <Route path="organisation" element={<OrganisationLayout />}>
                    <Route index element={<Navigate to="locations" />} />
                    <Route path={APP_ROUTES.organisationLocations.routePath} element={<OrganisationLocations />} />
                    <Route path={APP_ROUTES.organisationBrands.routePath} element={<OrganisationBrands />} />
                    <Route path={APP_ROUTES.organisationTeam.routePath} element={<OrganisationTeam />} />
                    <Route path={APP_ROUTES.organisationDetails.routePath} element={<OrganisationDetails />} />
                    <Route path={APP_ROUTES.organisationBilling.routePath} element={<Suspense fallback={<div role="status">Loading billing…</div>}><OrganisationBilling /></Suspense>} />
                  </Route>
                  {/* Reviews Pages */}
                  <Route path="/reviews" element={<ReviewsLayout />}>
                    <Route index element={<Navigate to="overview" replace />} />
                    <Route path={APP_ROUTES.reviewOverview.routePath} element={<ReviewsOverview />} />
                    <Route path={APP_ROUTES.reviewSentiment.routePath} element={<ReviewsDashboard />} />
                    <Route path={APP_ROUTES.reviewCompetitors.routePath} element={<ReviewsCompetitors />} />
                    <Route path={APP_ROUTES.reviews.routePath} element={<ReviewsList />} />
                    <Route path={APP_ROUTES.reviewLocations.routePath} element={<ReviewsLocations />} />
                    <Route path={APP_ROUTES.businessProfile.routePath} element={<ReviewsBusinessProfile />} />
                    <Route path={APP_ROUTES.posts.routePath} element={<ReviewsPosts />} />
                    <Route path={APP_ROUTES.reviewAiSettings.routePath} element={<ReviewsAISettings />} />
                  </Route>
                  {/* Surveys Pages */}
                  <Route path="/surveys" element={<SurveysLayout />}>
                    <Route index element={<Navigate to="analytics" />} />
                    <Route path={APP_ROUTES.surveyAnalytics.routePath} element={<SurveyAnalytics />} />
                    <Route path={APP_ROUTES.surveyTemplates.routePath} element={<SurveyTemplates />} />
                    <Route path={APP_ROUTES.surveyResponses.routePath} element={<SurveyResponses />} />
                  </Route>
                  {/* Survey Template Editor */}
                  <Route path="surveys/templates/editor/:templateId" element={<SurveyTemplateEditor />} />
                  {/* Profile Page */}
                  <Route path={APP_ROUTES.profile.routePath} element={<Profile />} />
                </Route>
                {/* <Route path="/insights" element={<InsightsLayout />}>
                  <Route index element={<Insights/>}/>
                  <Route path="footfall" element={<FootfallInsights />}/>
                  <Route path="footfall/show-all" element={<AllFootfallInsights />}/>
                  <Route path="external-insights" element={<ExternalImpactInsights />}/>
                  <Route path="external-insights/show-all" element={<AllExternalImpactInsights />}/>
                  <Route path="industry-news" element={<IndustryNewsInsights />}/>
                  <Route path="industry-news/show-all" element={<AllIndustryNewsInsights />}/>
                </Route> */}
              </Route>
              <Route path="*" element={<NotFound />} /> {/* Catch-all route for undefined paths */}
            </React.Fragment>
          )}
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
